import {FC} from "react";

interface ILoadingSpinnerProps {
  size?: number;
  borderRadius?: string;
  backgroundColor?: string;
  borderColor?: string;
  spinnerColor?: string;
  position?: "absolute" | "relative" | "static";
  zIndex?: number;
}

export const LoadingSpinner: FC<ILoadingSpinnerProps> = ({
  size = 50,
  borderRadius = "30%",
  backgroundColor = "#1e1e1e",
  borderColor = "#11A0DA",
  spinnerColor = "#11A0DA",
  position = "absolute",
  zIndex = 1,
}) => {
  const spinnerSize = Math.min(size * 0.4, 20);

  return (
    <>
      <style>
        {`
          @keyframes loadingSpinnerSpin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div
        style={{
          position: position,
          top: position === "absolute" ? 0 : undefined,
          left: position === "absolute" ? 0 : undefined,
          width: position === "absolute" ? "100%" : size,
          height: position === "absolute" ? "100%" : size,
          backgroundColor: backgroundColor,
          border: `2px solid ${borderColor}`,
          borderRadius: borderRadius,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: zIndex,
        }}
      >
        <div
          style={{
            width: spinnerSize,
            height: spinnerSize,
            border: "2px solid transparent",
            borderTop: `2px solid ${spinnerColor}`,
            borderRadius: "50%",
            animation: "loadingSpinnerSpin 1s linear infinite",
          }}
        />
      </div>
    </>
  );
};
